/**
 * Bot / crawler user-agent detection.
 *
 * Used to short-circuit work that has no value when a non-human client is
 * loading the page — currently:
 *   - service-worker registration (`main.tsx`)
 *   - client-side error reporting (`error-reporter.ts`)
 *
 * Pattern covers the major search-engine crawlers, social-card unfurlers,
 * monitoring probes, and headless automation runtimes. It deliberately stays
 * small — false negatives are fine (we'll still ship the rare error report),
 * but false positives on real browsers would silently break SW caching and
 * error visibility for users.
 */

const BOT_UA_PATTERN =
  /(googlebot|bingbot|baidu|yandex|duckduckbot|slurp|sogou|exabot|facebookexternalhit|twitterbot|linkedinbot|applebot|pingdom|headlesschrome|phantomjs|puppeteer|playwright|crawler|spider)/i;

export function isBotUserAgent(ua: string | undefined | null): boolean {
  if (!ua) return false;
  return BOT_UA_PATTERN.test(ua);
}
